import React from "react";
import { Link } from "react-router-dom";
import "./instruments.scss";

const instrumentsData = [
  {
    id: "forex",
    title: "Forex",
    subtitle: "Global Currency Markets",
    description:
      "Our AI analyzes macro trends and real-time data to execute high-probability trades across major and minor pairs without emotional bias.",
    img: "f.png",
  },
  {
    id: "crypto",
    title: "Crypto",
    subtitle: "24/7 Digital Asset Intelligence",
    description:
      "Navigate the decentralised market. Our AI masters volatility in Bitcoin and Altcoins to capture alpha in the most dynamic asset class.",
    img: "c.png",
  },
  {
    id: "stocks",
    title: "Stocks",
    subtitle: "Equity Growth & Precision",
    description:
      "Trade global equities with precision. From blue-chip tech to emerging growth, our AI monitors earnings and volume to optimize entries.",
    img: "st.png",
  },
  {
    id: "gold",
    title: "Gold",
    subtitle: "The Ultimate Safe Haven",
    description:
      "Leverage advanced analytics to capture strategic movements in gold, balancing portfolio stability with consistent growth opportunities.",
    img: "g.png",
  },
  {
    id: "silver",
    title: "Silver",
    subtitle: "Industrial Momentum",
    description:
      "Capitalize on Silver’s unique volatility. Our AI identifies momentum shifts driven by industrial demand and market sentiment.",
    img: "s.png",
  },
];

const Instruments = () => {
  return (
    <div className="__fw">
      <div className="instruments_page">
        <div className="banner">
          <img src={require("../../img/in_back.jpg")} alt="Banner" />
        </div>

        <div className="__mw">
          <div className="instruments_wrp">
            <header className="instruments_head">
              <h4>
                Trade High-Impact Instruments <em>with AI Precision</em>
              </h4>
              <p className="sub_headline">
                Smart market exposure across global assets — powered by
                intelligent automation
              </p>
              <p className="description">
                Select from carefully optimized trading instruments monitored
                and executed by our AI-driven Auto Trade system. Chosen for
                liquidity, volatility, and data reliability.
              </p>
            </header>

            <div className="int_grid">
              {instrumentsData.map((item) => (
                <div className="in_card" key={item.id}>
                  <div className="img_container">
                    <img
                      src={require(`../../img/${item.img}`)}
                      alt={item.title}
                    />
                  </div>
                  <div className="in_text">
                    <strong>{item.title}</strong>
                    <span>{item.subtitle}</span>
                    <p>{item.description}</p>
                  </div>
                  <Link to="/contact" className="card_link">
                    <button className="btn_pro">Trade with AI</button>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instruments;
